"use client";

import {
  type ElementType,
} from "react";

import {
  FacebookShareButton,
  LineShareButton,
  TwitterShareButton,
} from "react-share";

import {
  FacebookBwIcon,
  FacebookIcon,
  InstagramBwIcon,
  InstagramIcon,
  LineBwIcon,
  LineIcon,
  PinterestBwIcon,
  PinterestIcon,
  XBwIcon,
  XIcon,
  YoutubeBwIcon,
  YoutubeIcon,
} from "@/shared-web.ui/assets.social";
import { Flex } from "@/shared-web.ui/ui.flex";
import { Text } from "@/shared-web.ui/ui.text";

type ShareIconProps = {
  Icon: ElementType;
  IconBW: ElementType;
};
const ShareIcon = (props: ShareIconProps) => {
  const { Icon, IconBW } = props;

  return (
    <div
      className="group text-gray-11"
    >
      <span className={`
        hidden
        group-hover:inline
      `}
      >
        <Icon />
      </span>
      <span className={`
        inline text-inherit
        group-hover:hidden
      `}
      >
        <IconBW />
      </span>
    </div>
  );
};

export type SocialShareProps = {
  url: string;
  hashtags: string;
};
const SocialShare = (props: SocialShareProps) => {
  const { url, hashtags } = props;

  return (
    <Flex
      justify="end"
      align="center"
      gap="1"
      className="text-gray-11"
    >
      <Text>
        Share
      </Text>
      <FacebookShareButton hashtag={`#${hashtags}`} url={url}>
        <ShareIcon Icon={FacebookIcon} IconBW={FacebookBwIcon} />
      </FacebookShareButton>
      <TwitterShareButton hashtags={[hashtags]} url={url}>
        <ShareIcon Icon={XIcon} IconBW={XBwIcon} />
      </TwitterShareButton>
      <LineShareButton url={url}>
        <ShareIcon Icon={LineIcon} IconBW={LineBwIcon} />
      </LineShareButton>
    </Flex>
  );
};
export { SocialShare };
